import type { PresentationIsEmptyProps } from '../..'
export default function isEmpty({ section }: PresentationIsEmptyProps) {
  return false
}
